import { I18n } from '@editorjs/editorjs/types/api';
import { ButtonBuilder } from '../builders/button-builder';

export class ControlBuilderFacade {
  static buildRunCode(i18n: I18n, runCode: () => void | Promise<void>) {
    const builder = new ButtonBuilder();
    const icon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd" /></svg>`;

    return builder
      .withText(i18n.t('Run'))
      .withIcon(icon)
      .withId('run-code-button')
      .withOnClick(runCode)
      .build();
  }

  static buildResetButton(i18n: I18n, onReset: () => void) {
    const builder = new ButtonBuilder();

    const icon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
</svg>`;
    return builder
      .withText(i18n.t('Reset'))
      .withIcon(icon)
      .withId('reset-button')
      .withOnClick(onReset)
      .build();
  }
}
